import './search-header.scss'

import { defineComponent, PropType } from 'vue'

import { SearchParams } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { OptionsToolbar } from '../options-toolbar'
import { QueryInput } from '../query-input'
import { SEARCH_HEADER_SEARCH_DOMAIN_SELECTED } from '@skinsoft/bus';
import { DiscreteSelect, DISCRETE_SELECT_OPTION_SELECTED } from '@skinsoft/ui2'

export interface SearchDomainOption {
    value: number,
    text: string,
}

export const SearchHeader = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sOptionsToolbar: OptionsToolbar,
        sQueryInput: QueryInput,
        sDiscreteSelect: DiscreteSelect,
    },
    props: {
        title: {
            type: String,
        },
        barcodeEnabled: {
            type: Boolean,
        },
        sortingEntityFields: {},
        searchDomains: {
            type: Array as PropType<SearchDomainOption[]>
        },
    },
    template: require('./search-header.html'),
    data() {
        return {
            totalResults: null as any as number,
            searchParams: {
                nbResults: 15,
                queryText: '',
                sortAsc: true,
                sortType: [],
            } as SearchParams,
            DISCRETE_SELECT_OPTION_SELECTED: DISCRETE_SELECT_OPTION_SELECTED,
        }
    },
    mounted() {
        this.subscribeToBus('nb-results-changed', (message) => {
            this.totalResults = message.payload.totalResults
        })
    },
    methods: {
        onInputChange(value) {
            this.searchParams.queryText = value;
        },
        onOptionsChange(options: Partial<SearchParams>) {
            this.searchParams = {
                ...this.searchParams,
                ...options,
            };
        },
        onSearchDomainSelected(searchDomain: any) {
            this.$emit(SEARCH_HEADER_SEARCH_DOMAIN_SELECTED, searchDomain)
        },
    },
})
